module.exports = __webpack_public_path__ + "static/media/non_member_sample_basket_02.d63ac1df.jpg";